/* Kaung Khit — symptom-based supplement recommender */
(function () {
  'use strict';

  function init(root) {
    var dataEl = root.querySelector('[data-kk-data]');
    if (!dataEl) return;

    var DATA;
    try {
      DATA = JSON.parse(dataEl.textContent);
    } catch (e) {
      /* A malformed payload means a Liquid error leaked into the JSON — say so
         loudly rather than leaving a quiz that silently does nothing. */
      console.error('[kk-quiz] product payload is not valid JSON:', e.message);
      var snip = dataEl.textContent.slice(0, 400);
      console.error('[kk-quiz] payload starts:', snip);
      return;
    }
    var SYM = DATA.symptoms || [];
    var PROD = DATA.products || {};
    var MAX = Number(root.getAttribute('data-kk-max')) || 12;
    var PER = Number(root.getAttribute('data-kk-per')) || 3;

    var steps = root.querySelectorAll('[data-step]');
    var segs = root.querySelectorAll('[data-seg]');
    var errEl = root.querySelector('[data-kk-err]');
    var resultsEl = root.querySelector('[data-kk-results]');
    var summaryEl = root.querySelector('[data-kk-summary]');

    function show(n) {
      steps.forEach(function (s) { s.classList.toggle('is-active', s.dataset.step === String(n)); });
      segs.forEach(function (s) { s.classList.toggle('is-on', Number(s.dataset.seg) <= n); });
      var card = root.querySelector('.kk-quiz__card');
      if (card && card.getBoundingClientRect().top < 0) card.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }

    /* chip visual state */
    root.querySelectorAll('.kk-chip').forEach(function (chip) {
      var input = chip.querySelector('input');
      if (!input) return;
      function sync() {
        if (input.type === 'radio') {
          root.querySelectorAll('input[name="' + input.name + '"]').forEach(function (r) {
            var c = r.closest('.kk-chip');
            if (c) c.classList.toggle('is-on', r.checked);
          });
        } else {
          chip.classList.toggle('is-on', input.checked);
        }
      }
      input.addEventListener('change', sync);
      sync();
    });

    function picked() {
      var out = [];
      root.querySelectorAll('[data-sym]').forEach(function (i) {
        if (i.checked) out.push(Number(i.dataset.sym));
      });
      return out;
    }
    function radio(name, fallback) {
      var el = root.querySelector('input[name="' + name + '"]:checked');
      return el ? el.value : fallback;
    }

    var nextBtn = root.querySelector('[data-kk-next]');
    if (nextBtn) nextBtn.addEventListener('click', function () {
      if (!picked().length) {
        if (errEl) errEl.classList.remove('kk-hide');
        return;
      }
      if (errEl) errEl.classList.add('kk-hide');
      show(2);
    });

    var backBtn = root.querySelector('[data-kk-back]');
    if (backBtn) backBtn.addEventListener('click', function () { show(1); });

    var restartBtn = root.querySelector('[data-kk-restart]');
    if (restartBtn) restartBtn.addEventListener('click', function () {
      root.querySelectorAll('[data-sym]').forEach(function (i) {
        i.checked = false;
        i.dispatchEvent(new Event('change'));
      });
      show(1);
    });

    var goBtn = root.querySelector('[data-kk-go]');
    if (goBtn) goBtn.addEventListener('click', function () { recommend(); show(3); });

    function recommend() {
      var sel = picked();
      var who = radio('kkwho', 'self');
      var sex = radio('kksex', 'any');
      var chosen = sel.map(function (i) { return SYM[i]; }).filter(Boolean);
      var scored = [];

      Object.keys(PROD).forEach(function (pid) {
        var p = PROD[pid];
        var tags = String(p.g || '').split(',').map(function (t) { return t.trim(); });
        var score = 0;
        var why = null;

        chosen.forEach(function (s) {
          var hit = false;
          if (s.ids && s.ids.indexOf(Number(pid)) !== -1) { score += 2; hit = true; }
          if (s.tag && tags.indexOf(s.tag) !== -1) { score += 1.5; hit = true; }
          if (hit && !why) why = s.label;
        });
        if (score === 0) return;

        var isKid = tags.indexOf('kids') !== -1;
        if (who === 'kid') {
          if (!isKid) return;
          score += 3;
        } else if (isKid) {
          return;
        }
        if (who === 'parent') {
          ['bone-joint', 'eye', 'heart', 'daily', 'brain'].forEach(function (t) {
            if (tags.indexOf(t) !== -1) score += 0.75;
          });
        }

        if (sex === 'women') {
          if (tags.indexOf('women') !== -1) score += 1.5;
          if (tags.indexOf('men') !== -1) score -= 4;
        } else if (sex === 'men') {
          if (tags.indexOf('men') !== -1) score += 1.5;
          if (tags.indexOf('women') !== -1) score -= 4;
        } else {
          if (tags.indexOf('men') !== -1 || tags.indexOf('women') !== -1) score -= 0.4;
        }

        if (!p.a) score -= 1;
        if (score <= 0) return;
        scored.push({ id: pid, p: p, score: score, why: why });
      });

      scored.sort(function (a, b) { return b.score - a.score || (b.p.a - a.p.a); });

      /* keep the list varied: at most 2 per matched symptom */
      var perWhy = {};
      var final = [];
      scored.forEach(function (r) {
        if (final.length >= MAX) return;
        var k = r.why || '_';
        perWhy[k] = perWhy[k] || 0;
        if (perWhy[k] >= PER) return;
        perWhy[k]++;
        final.push(r);
      });
      if (final.length < 4) final = scored.slice(0, MAX);

      if (summaryEl) {
        summaryEl.textContent = chosen.length
          ? 'သင်ရွေးချယ်ခဲ့သည် — ' + chosen.map(function (s) { return s.label; }).join(' · ')
          : '';
      }

      if (!final.length) {
        resultsEl.innerHTML = '<p class="kk-quiz__hint">သင့်ရွေးချယ်မှုအတွက် ထုတ်ကုန် မတွေ့ပါ။ Messenger မှ တိုက်ရိုက် စုံစမ်းနိုင်ပါသည်။</p>';
        return;
      }

      resultsEl.innerHTML = final.map(function (r) {
        var p = r.p;
        var img = p.im
          ? '<img class="kk-res__img" src="' + p.im + '" alt="" loading="lazy" width="84" height="84">'
          : '<span class="kk-res__img" aria-hidden="true"></span>';
        var why = r.why ? '<span class="kk-res__why">' + esc(r.why) + '</span>' : '';
        var btn = p.a
          ? '<button type="button" class="kk-res__add" data-kk-add="' + p.v + '">စျေးဝယ်ခြင်းထဲ ထည့်ရန်</button>'
          : '<button type="button" class="kk-res__add" disabled>ပစ္စည်း မရှိပါ</button>';
        return '<div class="kk-res__item">' + img +
          '<div class="kk-res__body">' + why +
          '<a class="kk-res__name" href="' + p.u + '">' + esc(p.t) + '</a>' +
          '<span class="kk-res__price">' + esc(p.p) + '</span>' + btn +
          '</div></div>';
      }).join('');
    }

    function esc(s) {
      return String(s == null ? '' : s)
        .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;');
    }

    resultsEl.addEventListener('click', function (ev) {
      var btn = ev.target.closest('[data-kk-add]');
      if (!btn) return;
      var vid = btn.getAttribute('data-kk-add');
      var original = btn.textContent;
      btn.disabled = true;
      btn.textContent = 'ထည့်နေသည်…';

      fetch((window.routes && window.routes.cart_add_url ? window.routes.cart_add_url : '/cart/add') + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(vid), quantity: 1 }], sections: 'cart-icon-bubble' })
      })
        .then(function (r) { return r.json(); })
        .then(function (res) {
          if (res && res.sections && res.sections['cart-icon-bubble']) {
            var host = document.getElementById('cart-icon-bubble');
            if (host) {
              var tmp = document.createElement('div');
              tmp.innerHTML = res.sections['cart-icon-bubble'];
              var inner = tmp.querySelector('#cart-icon-bubble');
              host.innerHTML = inner ? inner.innerHTML : tmp.innerHTML;
            }
          }
          btn.textContent = '✓ ထည့်ပြီးပါပြီ';
          btn.classList.add('is-done');
        })
        .catch(function () {
          btn.textContent = original;
          btn.disabled = false;
        });
    });
  }

  function boot() {
    document.querySelectorAll('[data-kk-quiz]').forEach(init);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, { once: true });
  } else {
    boot();
  }
  document.addEventListener('shopify:section:load', function (e) {
    if (e.target && e.target.querySelector) e.target.querySelectorAll('[data-kk-quiz]').forEach(init);
  });
})();
